import { Checkbox, FormItemsGroup, Input, Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { CustomerType } from '@features/contacts/enums/customerType'

import { useMissingCustomerDetailsForm } from '../../../../contexts/missingCustomerDetailsFormContext'
import { getCustomerVatNoFieldConfig } from '../../../../utils/getCustomerVatNoFieldConfig'

export const CustomerTaxInfoSection = (): ReactElement | null => {
  const { t } = useTranslation()
  const { missingCustomerDetailsForm } = useMissingCustomerDetailsForm()

  const {
    FormItem,
    formState: { errors },
    setValue,
    trigger,
    watch,
  } = missingCustomerDetailsForm

  const [customerType, isVatExempted, customerCountryId] = watch(['customerType', 'isVatExempted', 'address.country'])
  const vatNumberErrorMessage = errors?.vatNumber?.message

  const { label: vatLabel, placeholder: vatPlaceholder } = getCustomerVatNoFieldConfig(customerCountryId, t)

  const handleVatExemptChange = useCallback(() => {
    setValue('vatNumber', undefined)

    if (vatNumberErrorMessage) {
      trigger('vatNumber')
    }
  }, [setValue, trigger, vatNumberErrorMessage])

  if (customerType !== CustomerType.Company) {
    return null
  }

  return (
    <FormItemsGroup rowSpacing={Spacing.S12}>
      <FormItem
        label={vatLabel}
        name="vatNumber"
        render={({ field }) => <Input {...field} disabled={isVatExempted} placeholder={vatPlaceholder} size="sm" />}
      />
      <FormItem
        name="isVatExempted"
        render={({ field: { value, onChange } }) => (
          <Checkbox
            checked={!!value}
            onChange={(event) => {
              onChange(event)
              handleVatExemptChange()
            }}
          >
            {t('external_invoices.missing_customer_compliance_details.modal.form.field.is_sales_tax_exempt.label')}
          </Checkbox>
        )}
      />
    </FormItemsGroup>
  )
}
